/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Sla_No_ConfigInputs */

const en_case_detail_sla_no_config = /** @type {(inputs: Case_Detail_Sla_No_ConfigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No SLA configured for this case.`)
};

const pt_br2_case_detail_sla_no_config = /** @type {(inputs: Case_Detail_Sla_No_ConfigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum SLA configurado para este caso.`)
};

/**
* | output |
* | --- |
* | "No SLA configured for this case." |
*
* @param {Case_Detail_Sla_No_ConfigInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_sla_no_config = /** @type {((inputs?: Case_Detail_Sla_No_ConfigInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Sla_No_ConfigInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_sla_no_config(inputs)
	return pt_br2_case_detail_sla_no_config(inputs)
});